// extracted by mini-css-extract-plugin
module.exports = {"landing":"Landing_landing__2STn3","title":"Landing_title__3W93L","button":"Landing_button__1Nnok"};